//Types
export const HOSPITAL_LOADING = "HOSPITAL_LOADING";
export const HOSPITAL_LOADED = "HOSPITAL_LOADED";
export const H_LOGIN_SUCCESS = "H_LOGIN_SUCCESS";
export const H_LOGIN_FAIL = "H_LOGIN_FAIL";
export const H_REGISTER_SUCCESS = "H_REGISTER_SUCCESS";
export const H_REGISTER_FAIL = "H_REGISTER_FAIL";
export const H_LOGOUT_SUCCESS = "H_LOGOUT_SUCCESS";
export const GENERAL_HOSPITAL_REDUCER = "GENERAL_HOSPITAL_REDUCER";
export const AUTH_ERROR = "AUTH_ERROR";
